var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLightbulb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 490 490",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 490,
    height: 490,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 245 81.3 C 170.8 81.3 117.2 136.6 108.7 196 C 103.4 235.6 116.2 274.2 142.8 303.4 C 166.2 328.4 179 361.8 179 396.2 L 178.9 450.4 C 178.9 472.3 197 490 219.4 490 L 271.6 490 C 294 490 312.1 472.3 312.1 450.4 L 312.2 396.2 C 312.2 360.8 323.9 328.4 346.3 305.5 C 370.8 280.5 383.6 248.2 383.6 214.8 C 383.5 140.7 320.6 81.3 245 81.3 L 245 81.3 Z  M 291.8 450.4 C 291.8 460.8 283.3 469.2 272.6 469.2 L 220.4 469.2 C 209.7 469.2 201.2 460.9 201.2 450.4 L 201.2 426.4 L 291.7 426.4 L 291.7 450.4 L 291.8 450.4 Z  M 331.4 290.9 C 304.8 318 290.9 355.5 290.9 396.2 L 290.9 405.6 L 200.4 405.6 L 200.4 396.2 C 200.4 357.6 184.4 319.1 157.8 289.9 C 134.4 264.9 124.8 232.6 129 199.2 C 136.5 149.2 183 102.2 245.1 102.2 C 310.1 102.2 362.3 153.3 362.3 214.8 C 362.3 242.9 351.6 270 331.4 290.9 Z ",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234.3,
    y: 0,
    width: 21.3,
    height: 50,
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 374.1 96.4 L 389 111.3 L 425.5 76.2 L 410.5 61.3 L 374.1 96.4 Z ",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 437.8,
    y: 225.2,
    width: 52.2,
    height: 20.9,
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 225.2,
    width: 52.2,
    height: 20.9,
    transform: "matrix(1,0,0,1,0,0)",
    style: {
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: " M 79.1 61.2 L 64.1 76.1 L 100.6 111.2 L 115.5 96.3 L 79.1 61.2 Z ",
    style: {
      fillRule: "evenodd"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightbulb);
export default __webpack_public_path__ + "static/media/lightbulb.ba53ba4afcafc2510443be821a011211.svg";
export { ForwardRef as ReactComponent };